import { EventEntity, EventSourceType, IdaQnAsEventStatus } from "@ctra/api";
import { memoize, TS } from "@ctra/utils";
import { i18nTranslate, Enterprise, Enterprise as Content } from "@ctra/i18n";

import { IdaQnAsEventView, IdaQnAsEventExpandIcon, IdaQnAsEventCta, IdaQnAEventPage } from "@events";
import { EventBase } from "./Base";
import * as _ from "lodash";

/**
 * IdaQnAs Event
 */
class IdaQnAEvent extends EventBase {
  /**
   * Get the metadata for the event
   */
  @memoize
  getContext(): {
    status: IdaQnAsEventStatus;
    urlParams: Map<string, EventEntity["source"]["id"]>;
    ctaText: string;
  } {
    const {
      source: { id, type },
      context: { sourceState }
    } = this.entity;

    const {
      events: {
        entity: { ctaText: cta }
      }
    } = Enterprise;

    return {
      status: sourceState as IdaQnAsEventStatus,
      urlParams: new Map([["QnAID", id]]),
      ctaText: i18nTranslate(cta(type), { status: sourceState })
    };
  }

  /**
   * Get the components for the event
   */
  @memoize
  getComponents(): ReturnType<typeof EventBase.prototype.getComponents> & {
    ExpandIcon: typeof IdaQnAsEventExpandIcon;
  } {
    return {
      ...super.getComponents(),
      Page: IdaQnAEventPage,
      View: IdaQnAsEventView,
      ExpandIcon: IdaQnAsEventExpandIcon,
      CTA: IdaQnAsEventCta
    };
  }

  /**
   * Get event description
   * @param params {{}}
   */
  @memoize
  getDescription(params?: Record<string, unknown>): string {
    const { description: originalDescription } = this.entity;

    const {
      entity: { description }
    } = Content.events;

    /**
     * Get rid of the "other:" text from the Ask Ida descriptions
     */
    const prettified = _.trim(_.defaultTo(originalDescription, "").replace("other:", ""));

    return i18nTranslate(description(EventSourceType.idaQnA), {
      ...params,
      originalDescription: prettified || null
    });
  }

  /**
   * End moment (same as start for now)
   * @todo find something more sustainable
   */
  @memoize
  getEndMoment(): ReturnType<typeof TS.asMoment> {
    return TS.asMoment(this.entity.startAt);
  }
}

export { IdaQnAEvent };
